export const SUPPORTED_LANGUAGES = {
	en: "en",
	ko: "ko",
	jp: "ja",
} as const;

export type Language =
	(typeof SUPPORTED_LANGUAGES)[keyof typeof SUPPORTED_LANGUAGES];

const ENV_LANGUAGE = import.meta.env.VITE_DEFAULT_LANGUAGE;

export const DEFAULT_LANGUAGE: Language = Object.values(
	SUPPORTED_LANGUAGES,
).includes(ENV_LANGUAGE)
	? (ENV_LANGUAGE as Language)
	: SUPPORTED_LANGUAGES.en;
